/** Специальный action для определения значений по-умолчанию
 * Определяет graph, текущий язык */
const Settings = {
    EMPTY: () => ({
        type: Settings.EMPTY,
    }),
    GRAPH: graph => ({
        type: Settings.GRAPH, graph
    }),
    LANG: lang => ({
        type: Settings.LANG, lang
    }),
    SIGNED: isSignedIn => ({
        type: Settings.SIGNED, isSignedIn
    })
}

export default Settings;
